// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.add-to-order-button {
  margin: 12px;
}

ion-button {
  width: 100%;
  --background: var(--ion-color-primary);
  --color: #ffffff;
  font-family: AppFontBold, sans-serif;
  letter-spacing: 1px;
  text-transform: uppercase;
  --border-radius: 50px;
  --box-shadow: none;
}

.wrapper {
  background-color: transparent;
}

.quantity {
  width: 28px;
  height: 28px;
  border: 1px solid #ffffff;
  border-radius: 50%;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 15px;
}
.quantity p {
  font-family: AppFont;
  font-size: 14px;
  line-height: 100%;
  letter-spacing: 0;
  text-align: center;
  vertical-align: middle;
  color: var(--color-white);
  transform: translateX(0.9px);
}`, "",{"version":3,"sources":["webpack://./src/app/components/to-order-button/to-order-button.component.scss"],"names":[],"mappings":"AAAA;EACC,YAAA;AACD;;AACA;EACC,WAAA;EACA,sCAAA;EACA,gBAAA;EACA,oCAAA;EACA,mBAAA;EACA,yBAAA;EACA,qBAAA;EACA,kBAAA;AAED;;AACA;EACC,6BAAA;AAED;;AACA;EACC,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AAED;AAAC;EACC,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;EACA,4BAAA;AAEF","sourcesContent":[".add-to-order-button {\n\tmargin: 12px;\n}\nion-button {\n\twidth: 100%;\n\t--background: var(--ion-color-primary); // Wyniger Gold\n\t--color: #ffffff; // White text\n\tfont-family: AppFontBold, sans-serif;\n\tletter-spacing: 1px;\n\ttext-transform: uppercase;\n\t--border-radius: 50px; // Pill shape\n\t--box-shadow: none;\n}\n\n.wrapper {\n\tbackground-color: transparent;\n}\n\n.quantity {\n\twidth: 28px;\n\theight: 28px;\n\tborder: 1px solid #ffffff; // White border\n\tborder-radius: 50%;\n\tbackground: transparent; // Remove dark bg\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tmargin-right: 15px;\n\n\tp {\n\t\tfont-family: AppFont;\n\t\tfont-size: 14px;\n\t\tline-height: 100%;\n\t\tletter-spacing: 0;\n\t\ttext-align: center;\n\t\tvertical-align: middle;\n\t\tcolor: var(--color-white);\n\t\ttransform: translateX(0.9px);\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
